import { Stack } from "@mui/material";
import { BodyTextM, cs, HeadingXL } from "@repo/ui";
import { Formik } from "formik";
import { type FC } from "react";
import Attentions from "./Attentions";
import CallToAction from "./CallToAction";
import PortalResult from "./PortalResult";
import Result from "./Result";
import PensionSlider from "./Slider";

const PensionCalculator: FC<{
    monthlyContribution?: number;
    portalVersion?: boolean;
    changeContributionUrl?: string;
    onChangeContribution?: (newContribution?: number) => void;
}> = ({ monthlyContribution = 1700, portalVersion, changeContributionUrl, onChangeContribution }) => {
    return (
        <Formik
            initialValues={{
                amount: monthlyContribution,
            }}
            onSubmit={(values, { setSubmitting }) => {
                setSubmitting;
            }}
        >
            {({ values }) => {
                return (
                    <>
                        <Stack sx={{ px: 6 }}>
                            <HeadingXL sx={{ mb: 4 }}>{cs.pensionCalculator.intro.heading}</HeadingXL>
                            <Stack sx={{ mb: 5 }}>
                                <BodyTextM>
                                    {cs.pensionCalculator.intro.description1}{" "}
                                    <BodyTextM strong>{cs.pensionCalculator.intro.description2}</BodyTextM>
                                </BodyTextM>
                            </Stack>
                        </Stack>
                        <PensionSlider />
                        <Stack
                            sx={{
                                mt: 6,
                                py: 5,
                                px: 6,
                                borderTop: "1px solid #ddd",
                                borderBottom: "1px solid #ddd",
                                background: "#F7F7F7",
                            }}
                            spacing={4}
                        >
                            {portalVersion ? <PortalResult monthlyContribution={monthlyContribution} /> : <Result />}
                            <Attentions />
                        </Stack>
                        <CallToAction
                            portalVersion={portalVersion}
                            onChangeContribution={onChangeContribution}
                            newContribution={values.amount}
                        />
                    </>
                );
            }}
        </Formik>
    );
};

export default PensionCalculator;
